import { defineMessages } from 'react-intl';

export const integrationsMessages = defineMessages({
  title: {
    id: 'integrations.title',
    defaultMessage: 'Integrations',
  },
  bannerTitle: {
    id: 'integrations.banner.title',
    defaultMessage: 'ClassPass integrations',
  },
  bannerSubtitle: {
    id: 'integrations.banner.subtitle',
    defaultMessage: 'Supercharge your account by connecting to the tools you use',
  },
  bannerBulletOne: {
    id: 'integrations.banner.bullet-one',
    defaultMessage: 'Unlock SmartSpot',
  },
  bannerBulletTwo: {
    id: 'integrations.banner.bullet-two',
    defaultMessage: 'Prevent double bookings',
  },
  bannerBulletThree: {
    id: 'integrations.banner.bullet-three',
    defaultMessage: 'Automate your schedule management',
  },
  allIntegrationsDesktop: {
    id: 'integrations.filter.all-integrations-desktop',
    defaultMessage: 'All Integrations',
  },
  allIntegrationsMobile: {
    id: 'integrations.filter.all-integrations-mobile',
    defaultMessage: 'All',
  },
  filterAppointments: {
    id: 'integrations.filter.appointments',
    defaultMessage: 'Appointments',
  },
  filterClasses: {
    id: 'integrations.filter.classes',
    defaultMessage: 'Classes',
  },
  filterFoodAndBev: {
    id: 'integrations.filter.food-and-bev',
    defaultMessage: 'Food & beverage',
  },
  searchPlaceholder: {
    id: 'integrations.search.placeholder',
    defaultMessage: 'Search integrations',
  },
  loadError: {
    id: 'integrations.load.error',
    defaultMessage: 'There was a problem loading integrations data.',
  },
});

export const integrationsFormMessages = defineMessages({
  title: {
    id: 'integrations.form.title',
    defaultMessage: 'Integrate with {integratorName}',
  },
  namePlaceholder: {
    id: 'integrations.form.name-placeholder',
    defaultMessage: 'First Last',
  },
  nameLabel: {
    id: 'integrations.form.name-label',
    defaultMessage: 'Full name',
  },
  emailLabel: {
    id: 'integrations.form.email-label',
    defaultMessage: 'Email',
  },
  emailPlaceholder: {
    id: 'integrations.form.email-placeholder',
    defaultMessage: 'Email address',
  },
  phoneLabel: {
    id: 'integrations.form.phone-label',
    defaultMessage: 'Phone number',
  },
  phonePlaceholder: {
    id: 'integrations.form.phone-placeholder',
    defaultMessage: 'Your phone number',
  },
  invalidEmail: {
    id: 'integrations.form.invalid-email',
    defaultMessage: 'Please enter a valid email address.',
  },
  submitted: {
    id: 'integrations.form.submitted',
    defaultMessage:
      'Your integration request has been submitted! A team member will reach out to you in the next 48 hours to complete your integration.',
  },
  integrationGuide: {
    id: 'integrations.form.integration-guide',
    defaultMessage: '{integratorName} Integration Guide',
  },
  dismiss: {
    id: 'integrations.form.dismiss',
    defaultMessage: 'Dismiss',
  },
  genericError: {
    id: 'integrations.form.error',
    defaultMessage: 'Something went wrong... Please try again later.',
  },
});
